import React, { useState } from "react";
import styled from "@emotion/styled";
import { IoLockOpenOutline } from "react-icons/io5";

import FormHelper from "../../utils/FormHelper";
import Form from "./Form";
import FormBox from "./FormBox";
import { FaArrowRight } from "react-icons/fa6";
import { BREAKPOINTS } from "../../utils/consts";
import SocialLogin from "../SocialLogin/SocialLogin";
import StyledLink from "../Molecules/StyledLink";

const LoginBox = (props) => {
  const { navigate, location, dataHelper, userHelper, message, popup, config } =
    props;

  const [loading, setLoading] = useState(0);

  const goToForgotPassword = (e) => {
    e.preventDefault();

    const username = inputs.Username.getValue();

    navigate("/redefinir-senha", { state: { username } });
  };

  const inputs = Loginform({
    goToForgotPassword,
    config,
  });

  const handleLogin = async (formData) => {
    const username = formData["Username"].toLowerCase();

    const password = formData["Password"];
    let response = await props.userHelper.userLogin(username, password);

    if (response?.success) {
      global.isAuthenticated = true;

      return {
        success: true,
        redirect: "/",
      };
    } else {
      if (response?.error?.code) {
        switch (response.error.code) {
          case "auth/user-not-found":
            inputs.Username.focusError(`Usuário não encontrado`);
            break;
          case "auth/wrong-password":
            inputs.Password.focusError(`Senha inválida`);
            break;
          case "auth/user-disabled":
            inputs.Username.focusError(
              `Conta desabilitada. Por favor, entre em contato para mais informações.`
            );
            break;
          case "auth/too-many-requests":
          default:
            message.add({
              type: "error",
              message: `Não foi possível logar. Por favor, tente novamente mais tarde.`,
            });
        }
      } else if (response?.message) {
        message.add({ type: "error", message: response.message });
      } else {
        message.add({
          type: "error",
          message: `Não foi possível processar sua requisição. Por favor, tente novamente mais tarde.`,
        });
      }
    }
  };

  return (
    <StyledLoginBox>
      <FormBox
        {...props}
        title={`Login`}
        description={`Acesse com seu login do aplicativo do Palmeiras`}
        hintIcon={<IoLockOpenOutline />}
        className="form-box"
        config={config}
        inside={
          <div>
            <Form
              gridConfig={{
                desktopQty: 4,
              }}
              navigate={navigate}
              location={location}
              dataHelper={dataHelper}
              inputs={inputs}
              handleSend={handleLogin}
              loading={loading}
              config={config}
              setLoading={setLoading}
            />
          </div>
        }
      />
      <div className="sign-up">
        <span className="have-account-txt">Não possui uma conta?</span>
        <StyledLink to="/cadastro" config={config}>
          Registre-se
          <FaArrowRight />
        </StyledLink>
      </div>
      <SocialLogin
        navigate={navigate}
        location={location}
        userHelper={userHelper}
        popup={popup}
        dataHelper={dataHelper}
        message={message}
      />
    </StyledLoginBox>
  );
};

export default LoginBox;

/* form */

const Loginform = (props) => {
  return {
    Username: FormHelper.useFormInput({
      label: `E-mail`,
      type: "text",
      validations: [
        {
          type: "required",
          errorMessage: `Digite um E-mail`,
        },
        {
          type: "username",
          errorMessage: `Digite um E-mail válido`,
        },
      ],
      inputOptions: {
        spellCheck: false,
      },
      mask: "username",
      maskOptions: ["text", "cpf"],
    }),
    Password: FormHelper.useFormInput({
      label: `Senha`,
      type: "password",
      validations: [
        {
          type: "required",
          errorMessage: `Digite sua senha`,
        },
      ],
    }),
    ForgotPasswordLink: FormHelper.useFormInput({
      type: "content",
      content: (
        <div className="forgot-password-link">
          <StyledLink
            href={"#"}
            className="styled-link"
            config={props?.config}
            onClick={(e) => props.goToForgotPassword(e)}
          >
            Esqueceu sua senha?
          </StyledLink>
        </div>
      ),
    }),
  };
};

/* style */

const StyledLoginBox = styled.div`
  display: flex;
  flex-direction: column;
  gap: 48px;
  align-items: center;
  margin-top: 42px;
  padding-bottom: 42px;

  @media (max-width: ${BREAKPOINTS.PHONE}px) {
    gap: 24px;
  }

  .forgot-password-link {
    text-align: center;
  }

  .sign-up {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    gap: 16px;

    .have-account-txt {
      font-family: "Roboto";
      font-size: 18px;
      line-height: 28px;
      font-weight: 400;
      color: #8c8c8c;
    }
  }
`;
